import { Component, inject, OnInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UtilService } from '@services/util.service';
import { LoginService, UserDetails } from '@services/login.service';
import { CompanyDetails } from '@models/registration.models';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'app-company-selection',
  standalone: true,
  imports: [
    CommonModule
  ],
  template: `
    <div class="company-section">
      <h5>Company Details</h5>
      
      <!-- Selected Company Details -->
      @if (selectedCompany) {
        <div class="selected-company-details">
          <div class="company-info-card">
            <div class="info-row">
              <strong>Company Name:</strong> {{ selectedCompany.name }}
            </div>
            <div class="info-row">
              <strong>Company ID:</strong> {{ selectedCompany.number }}
            </div>
            <div class="info-row">
              <strong>Company Type:</strong> {{ selectedCompany.type }}
            </div>
          </div>
        </div>
      }
    </div>
  `,
  styles: [`
    .company-section {
      margin: 1rem 0;
    }
    
    .selected-company-details {
      margin-top: 1rem;
      padding: 1rem;
      border: 1px solid #e0e0e0;
      border-radius: 4px;
      background-color: #f9f9f9;
    }
    
    .company-info-card {
      display: flex;
      flex-direction: column;
      gap: 0.5rem;
    }
    
    .info-row {
      display: flex;
      align-items: center;
      gap: 0.5rem;
    }
    
    .info-row strong {
      min-width: 120px;
    }
  `]
})
export class CompanySelectionComponent implements OnInit, OnDestroy {
  private utilService = inject(UtilService);
  private loginService = inject(LoginService);
  
  // Company data
  selectedCompany: CompanyDetails | null = null;
  private destroy$ = new Subject<void>();
  
  // Get logged in user details
  get loggedInUser(): UserDetails | null {
    return this.loginService.loginUser;
  }

  ngOnInit(): void {
    // Check if logged-in user has company information and prefill
    this.checkAndPrefillCompanyInfo();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  private checkAndPrefillCompanyInfo(): void {
    const user = this.loggedInUser;
    if (user && user.companyId && user.companyName) {
      // User has company information, search by company ID and prefill
      // this.utilService.searchCompanyById(user.companyId).subscribe(company => {
      this.utilService.getCompanyDetailsFromLoginUser(user).subscribe(company => {
        if (company) {
          this.selectedCompany = company;
        }
      });
    }
  }
}
